/* eslint-disable react/jsx-pascal-case */
import {
    Col, Form, Input, Row, Select, DatePicker, Switch
} from "antd";
import { useKeyword } from "../../keyword/controller/KeywordController";
import { useMesaageTemplate } from "../../mesaage_template/controller/MesaageTemplateController";
import { useCan } from "../../can/controller/CanController";
import { useAutoReply } from "../../auto_reply/controller/AutoReplyController";
import React, { useEffect } from "react";

const CheckoutForm = (
    {
        propsForm = null,
        axiosMode = "post",
        formReloadCount = 0,
        onFormFinish = () => { },
    }
) => {
    const [form] = Form.useForm();

    const setFormValuesOtherThings = (formValues) => {
        //做一些你可能會用到其他component的資料整理
        let newFormValues = {
            ...formValues,
            total: (formValues?.comments * formValues?.number) || 0
        }
        if (propsForm) {
            propsForm.setFieldsValue(newFormValues)
        }
        else {
            form.setFieldsValue(newFormValues)
        }

    }

    const setDataInitialization = () => {
        //拿個下拉選單等等的資訊
    }
    const onFinish = (values) => {
        onFormFinish({
            ...values,
        })

    }
    const onValuesChange = () => {
        let formValues = null
        if (propsForm) {
            formValues = propsForm.getFieldsValue()
        }
        else {
            formValues = form.getFieldsValue()
        }
        setFormValuesOtherThings(formValues)
    }
    const {
        getAutoReplyOption,
        autoReplyOption
    } = useAutoReply({
        onFinish: () => { },
        onBefore: () => { },
    })
   
    const {
        getCanOption,
        canOption,
    } = useCan({
        onFinish: () => { },
        onBefore: () => { },
    })
    useEffect(() => {
        setDataInitialization()
        getAutoReplyOption()
        getCanOption()
    }, [])

    useEffect(() => {

        let formValues = null
        if (propsForm) {
            formValues = propsForm.getFieldsValue()
        }
        else {
            formValues = form.getFieldsValue()
        }
    }, [formReloadCount])

    return (
        <Row>
            <Col span={24}>
                <Form
                    labelCol={{ span: 6 }}
                    wrapperCol={{ span: 18 }}
                    layout="horizontal"
                    form={propsForm ? propsForm : form}
                    onValuesChange={onValuesChange}
                    onFinish={onFinish}
                    autoComplete="off"
                >
                    <Row gutter={[8, 8]}>

                        <Col span={24}>
                            <Form.Item
                                hidden={true}
                                label={"checkout_id"}
                                name={"checkout_id"}
                            >
                                <Input>
                                </Input>
                            </Form.Item>
                        </Col>
                        <Col span={24}>
                            <Form.Item
                                hidden={true}
                                label={"checkout_id_sierra"}
                                name={"checkout_id_sierra"}
                            >
                                <Input>
                                </Input>
                            </Form.Item>
                        </Col>


                        <Col span={24}>
                            <Form.Item
                                label={"訊息樣板"}
                                name={"can_id"}
                                rules={[
                                    {
                                        required: true,
                                        message: "請輸入"
                                    }
                                ]}
                            >
                                <Select
                                    options={canOption}
                                >
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col span={24}>
                            <Form.Item
                                hidden={true}
                                label={"checkout_can_id"}
                                name={"checkout_can_id"}
                            >
                                <Input>
                                </Input>
                            </Form.Item>
                        </Col>

                    </Row>
                </Form>
            </Col>
        </Row>
    )
}



export default CheckoutForm;
